<template>
  <el-select
    class="width-100"
    v-model="value"
    filterable
    remote
    :placeholder="placeholder ? placeholder : 'Gõ để tìm kiếm'"
    :remote-method="remoteMethod"
    @change="$emit('input', value)"
    :loading="loading">
    <el-option
      v-for="item in clients"
      :key="item.id"
      :label="`${item.name} - ${item.shop_name}`"
      :value="item.id">
    </el-option>
  </el-select>
</template>
<script>
import { getAllClients } from 'src/api/clients'
export default {
  name: 'SelectClient',
  props: ['value', 'placeholder'],
  data () {
    return {
      clients: [],
      loading: false
    }
  },
  methods: {
    remoteMethod (query) {
      this.loading = true
      getAllClients({q: query}).then(response => {
        this.loading = false
        this.clients = response.data
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectClient.vue?ec3ecf38